// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1___eaf8758fd72c5492da7","cls2":"Cta-cls2__ff0e3655a0a0e0ecaebc Cta-cls1___eaf8758fd72c5492da7"};